<template>
    <main-layout>
        <template #breadcrumbs>
            <span class="union-icon">
                <i class="feather-tag"></i>
            </span>
            <span class="repo-chart-title">
                <inertia-link :href="route('home')">
                    <span class="repo-text">Repositories</span>
                </inertia-link>
                <span class="d-line">/ </span>
                <inertia-link :href="route('repository.view', {team: team})">
                    <span class="repo-text">{{ team.slug }}</span>
                </inertia-link>
                <span class="d-line">/ </span>
                Upload a Helm Chart
            </span>
        </template>
        <template #pageTitle>
            <h2 class="mb-1">Upload Helm Chart</h2>
            <span class="sm-text">Use your browser to upload helm chart as an archive into repository</span>
        </template>

        <div>
            <div class="title-col2">
                <h2 class="md-title">Publish your helm chart</h2>
                <h4 class="theme-color">How to create package to upload (video)</h4>
                <a href="javascript:void(0);" class="link-btn"><span>see video tutorial</span><span><i
                    class="feather-play-circle"></i></span></a>
            </div>
            <div class="card-style my-sm-4 my-3">
                <span class="command-title">To prepare file for upload run following command:</span>
                <p class="command-text">helm package < helm chart path ></p>
            </div>

            <div class="title-col2">
                <h2 class="mb-3">Select chart file</h2>
            </div>
            <div class="upload-file text-center">
                <label for=""><i class="feather-upload-cloud pb-1"></i><br>
                    <span class="file-title">Drag and Drop a chart archive here</span>
                    <p class="file-click-title mb-0">or click to open file selection dialog</p>
                    <input type="file" name="upload" class="form-control" id="">
                </label>
            </div>
            <!-- <small class="required mt-3">Invalid helm chart. Please select another file.</small> -->
            <div class="btn-list mw-100 text-start mt-4">
                <ul>
                    <li>
                        <button class="btn btn-style btn-primary w-172 " disabled><span>Upload Chart</span></button>
                    </li>
                    <li>
                        <button class="btn btn-style btn-outline w-172"><span>Cancel</span></button>
                    </li>
                </ul>
            </div>
        </div>
    </main-layout>
</template>

<script>
    import MainLayout from "@/Layouts/MainLayout";

    export default {
        name: "UploadHelmChart",
        components: {MainLayout},
        props: ['team']
    }
</script>

<style scoped>

</style>
